import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const MafsalliTenteTamiriPage = () => {
  useEffect(() => {
    document.title = 'Mafsallı Tente Tamiri - İzmir Tente Tamir | Profesyonel Tamir';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde mafsallı tente tamiri hizmeti. Kol arızaları, mafsallarda kırılma ve tüm mafsallı tente sorunlarına uzman çözümler. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' },
    { title: 'Körüklü Tente Tamiri', link: '/hizmetler/koruklu-tente-tamiri' },
    { title: 'Branda Değişimi', link: '/hizmetler/branda-degisimi' },
    { title: 'Tente Yenileme', link: '/hizmetler/tente-yenileme' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/e2a66781ccb6b219ef306236733e80fd.jpg"
            alt="Mafsallı Tente Tamiri"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Mafsallı Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                İzmir Tente Tamir
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Mafsallı tenteler, katlanabilir kol sistemi sayesinde pratik kullanım sunan ve balkon, teras, bahçe gibi alanlarda yaygın olarak tercih edilen tente türleridir. Açılıp kapanabilen kol mekanizması, hem kullanım kolaylığı hem de uzun ömür sağlar. İzmir Tente Tamir olarak, mafsallı tentelerinizin tüm tamir ve bakım ihtiyaçlarına profesyonel çözümler sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Mafsallı Tente Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Mafsallı tente, teleskopik kollar ve mafsallar aracılığıyla açılıp kapanan bir tente sistemidir. Kollar, yaylı veya gazlı piston mekanizması ile desteklenir ve tentenin istenilen açıda durmasını sağlar. Bu sistem sayesinde tente hem manuel hem de motorlu olarak kullanılabilir.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Mafsallı Tentelerde Karşılaşılan Sorunlar</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Mafsallı tenteler, mekanik yapıları nedeniyle bazı özel sorunlarla karşılaşabilir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kol Kırılması veya Bükülmesi:</strong> Aşırı rüzgar veya yanlış kullanım sonucu kollarda hasar oluşabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Mafsallarda Gevşeme:</strong> Zamanla mafsallar gevşeyebilir ve tente sallanmaya başlayabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yay veya Piston Arızası:</strong> Kolları destekleyen yay veya pistonlar zayıflayabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Branda Yırtılması:</strong> Kumaşta yırtık, delik veya aşınma meydana gelebilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Açılma-Kapanma Zorluğu:</strong> Mekanizma kirlenmesi veya yağ eksikliği nedeniyle hareket zorlaşabilir.</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Mafsallı Tente Tamir Hizmetlerimiz</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                İzmir Tente Tamir olarak mafsallı tenteler için sunduğumuz tamir hizmetleri:
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Kol Tamiri ve Değişimi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Kırılmış, bükülmüş veya hasarlı kolları tamir ediyor veya yenileriyle değiştiriyoruz. Orijinal yedek parça kullanımına özen gösteriyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Mafsallarda Sıkılaştırma ve Onarım</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Gevşemiş mafsalları sıkılaştırıyor, aşınmış parçaları değiştiriyoruz. Böylece tenteniz yeniden sağlam ve dengeli çalışır.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Yay ve Piston Değişimi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Zayıflamış yay veya pistonları yenileriyle değiştirerek tentenizin kolayca açılıp kapanmasını sağlıyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Branda Onarımı ve Yenileme</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Yırtık ve delikleri onarıyor, gerektiğinde brandayı tamamen yeniliyoruz. Geniş renk ve desen seçenekleri sunuyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Mekanizma Bakımı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Tüm hareketli parçaları temizliyor, yağlıyor ve ayarlıyoruz. Böylece tenteniz sorunsuz çalışır.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tamir Süreci</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Mafsallı tente tamir sürecimiz şu adımlardan oluşur:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Ücretsiz Keşif:</strong> Tentenizi yerinde inceleyerek sorunları tespit ediyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Fiyat Teklifi:</strong> Yapılacak işlemler ve maliyetler hakkında detaylı bilgi veriyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Tamir:</strong> Onayınızın ardından tamir işlemini kısa sürede tamamlıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Test ve Teslim:</strong> Tamir sonrası kapsamlı test yaparak size teslim ediyoruz</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden Bizi Tercih Etmelisiniz?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzman Kadro:</strong> Mafsallı tente mekanizmaları konusunda deneyimli teknisyenlerimiz var</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Orijinal Yedek Parça:</strong> Kaliteli ve uyumlu yedek parçalar kullanıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Servis:</strong> Aynı gün veya ertesi gün tamir imkanı sunuyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uygun Fiyat:</strong> Şeffaf ve rekabetçi fiyatlandırma yapıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm tamir işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Mafsallı tente tamiriniz için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MafsalliTenteTamiriPage;